import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { CustomConfirmModalComponent } from "../shared-component/custom-confirm-modal/custom-confirm-modal.component";
const ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false
};


export function formSubmit(fForm: any, model: NgbModal) : boolean {	
	let isValid = true;
	const inputElements = document.getElementsByTagName("input");
	if (!validateRadioGroups(fForm,inputElements)) {
		isValid = false;
		const title = "Confirmation"
        const body = "Questions in highlighted rows are required and have not been answered.  Please provide answers."
        displayAlert(title, body, model)
		
	} else {
		for (let i=0; i < inputElements.length; i++)  {
			if (inputElements[i].type === "text" && !validateTextField(inputElements[i])) {	
				isValid = false;
				(<HTMLElement>inputElements[i].parentNode?.parentNode?.parentNode).style.backgroundColor = "#faa"		
			}
		}
		if (!isValid) {
			const title = "Confirmation"
        	const body = "The highlighted rows are required and only numeric characters are allowed.  " +
						 "Please correct the answer."
        	displayAlert(title, body, model)	
		}		
	}	
	/*if (isValid) {
		document.getElementById("bSubmit").disabled = true;
		document.getElementById("bBack").disabled = true ;		
	} else {	
		cancelEvent(evnt);	
	}*/
	return isValid ;
}

export function processNavClk(event : any,fForm: any, model: NgbModal): boolean {
	const inputElements = document.getElementsByTagName("input");
	//const clickedElem = event.target ? event.target : event.srcElement;
	let canProceed = true;
	const el =  document.getElementById("level_table");
	if (event === "prevPageNav") {
		
		// ok
		
	// can not proceed to next page until all questions answered correctly
	} else if (!validateRadioGroups(fForm,inputElements)) {
		
		canProceed = false;
		const title = "Confirmation"
        const body = "Questions in highlighted rows are required and have not been answered.  Please provide answers."
        displayAlert(title, body, model)
	
	}else {
		
		for (let i=0; i < inputElements.length; i++)  {
			
			if (inputElements[i].type === "text" && !validateTextField(inputElements[i])) {
				canProceed = false;
				(<HTMLElement>inputElements[i].parentNode?.parentNode?.parentNode).style.backgroundColor = "#faa"	
			}
		}
		
		if (!canProceed) {
			const title = "Confirmation"
        	const body = "The highlighted rows are required and only numeric characters are allowed. Please correct the answers."
        	displayAlert(title, body, model)
		}
	}	

	// can go to next page only if all questions are answered correctly
	if ( canProceed ) {	
	
		cnlRowEvents(inputElements,model);
		return true ;
		
	} 
	return false ;
}

	export function validateTextField(event : any) : boolean{
		const inputElObj = event.value;
		const isValid = ( (inputElObj.length > 0) && (inputElObj.search(new RegExp("\\D")) === -1) ) ? true : false;
		return isValid;
	}


	export function cnlRowEvents(target: HTMLCollectionOf<HTMLInputElement>,model : any) : void {
	
		const inputElements = target ;
		
		for(let i=0; i<inputElements.length; i++) {
			
			if (inputElements[i].type === "radio") {
				
			inputElements[i].addEventListener('click', () => {
				clearRadioError(inputElements[i]);
			})
				
			} else if (inputElements[i].type === "text"){	
				inputElements[i].addEventListener('change', () => {
					processTextField(inputElements[i],model);
				})
			}
	
		}
		
	}

	export function clearRadioError(evnt : any) : void{
		//const inputElem = evnt.target ? evnt.target : evnt.srcElement; 
		evnt.parentNode.parentNode.parentNode.style.backgroundColor = "";
	}

	export function processTextField(evnt : any, model : any) : void{ 
		//const inputElem = evnt.target ? evnt.target : evnt.srcElement; 
		if (validateTextField(evnt)) {	
			evnt.parentNode.parentNode.parentNode.style.backgroundColor = "";	
		} else {	
			evnt.parentNode.parentNode.parentNode.style.backgroundColor = "#faa";
			const title = "Confirmation"
        	const body = "The highlighted rows are required and only numeric characters are allowed. Please correct the answers."
        	displayAlert(title, body, model)
			
			//cancelEvent(evnt);
			
		}
		
	}

export function validateRadioGroups(fForm: any, target: HTMLCollectionOf<HTMLInputElement>): boolean {
    
    let isValid = true;
    let sOldName = "";
    const inputElements = target
    for (let i = 0; i < inputElements.length; i++) {
        const data = inputElements[i].name
        const answer = fForm.get(inputElements[i].name)?.value
        if ((sOldName !== inputElements[i].name) && (inputElements[i].type === "radio")) {
             if (answer === "") {
				isValid=false;
                // highlight the row
                (<HTMLElement>inputElements[i].parentNode?.parentNode?.parentNode).style.backgroundColor = "#faa"
            }
            sOldName = inputElements[i].name;
        }
    }
   
    return isValid;
}

export function clearError(target: HTMLInputElement): void {
    (<HTMLElement>target.parentNode?.parentNode?.parentNode).style.backgroundColor = ""
}


function displayAlert(title: string, body: string, model: NgbModal): void {
    const modalRef = model.open(CustomConfirmModalComponent, ngbModalOptions)
    modalRef.componentInstance.cModalTitle = title
    modalRef.componentInstance.cModalBody = body
}
